import type { GetDocumentInternalAuditResultByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetDocumentInternalAuditResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDocumentInternalAuditResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDocumentInternalAuditResultByIdArgs = {
  id: string;
};

export const useGetDocumentInternalAuditResultById = createQueryHook<
  UseGetDocumentInternalAuditResultByIdArgs,
  GetDocumentInternalAuditResultByIdResponseRow[],
  GetDocumentInternalAuditResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.internalAuditResult.documentInternalAuditResultById.queryOptions(
      { id }
    ),
  mapTrpcDataToGraphQL: (data) => ({
    document_internal_audit_result: data,
  }),
  graphqlDocument: GetDocumentInternalAuditResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
